// extracted by mini-css-extract-plugin
export default {"skeletonLine":"SkeletonLine-skeletonLine-2Id","pulse":"SkeletonLine-pulse-TL2"};